module.exports = __webpack_public_path__ + "static/media/Madfit_Website_11.0f0e8242.jpg";